import Heading from 'components/Luxkit/Typography/Heading'
import PaletteProvider from 'contexts/PaletteProvider'
import { ExperienceBookmarkButton } from 'tripPlanner/components/Bookmark/BookmarkButton'
import TripGuard from 'tripPlanner/components/TripGuard/TripGuard'
import React, { useMemo } from 'react'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import ExperienceLocationCaption from 'home/components/OfferCarousels/common/OfferCards/ExperienceLocationCaption'
import ProductTypeLabel from 'components/Luxkit/Label/ProductTypeLabel'
import HeroExperienceOfferTilePricing from '../Support/HeroExperienceOfferTilePricing'
import BodyText from 'components/Luxkit/Typography/BodyText'

const DetailContainer = styled(Group)`
  height: 100%;
  padding-top: ${rem(16)};
  background-color: ${props => props.theme.palette.neutral.eight};
  ${mediaQueryUp.desktop} {
    flex: 1;
    padding: ${rem(16)} ${rem(32)} ${rem(32)} ${rem(32)};
  }
`

const MinHeightGroup = styled(Group)`
  min-height: ${rem(260)};
  flex-grow: 1;
`

interface Props {
  isDesktop: boolean;
  experience: App.ExperienceOffer;
}

function HeroExperienceOfferDetails({ isDesktop, experience }: Props) {
  const hasFullRefund = useMemo(() => experience.copy.cancellationInfo.refundPolicies?.some(policy => policy.value === 100 && policy.type === 'PERCENTAGE'), [experience.copy.cancellationInfo.refundPolicies])

  return (
    <PaletteProvider type={isDesktop ? 'default' : 'inverse'}>
      <DetailContainer direction="vertical" gap={16} >
        <TripGuard>
          {isDesktop && (
            <Group direction="horizontal-reverse">
              <ExperienceBookmarkButton offer={experience} />
            </Group>
          )}
        </TripGuard>
        <MinHeightGroup gap={16} tabletGap={24} direction="vertical" verticalAlign="space-between" fullHeight>
          <Group direction="vertical" gap={4}>
            <ExperienceLocationCaption location={experience.location.name} primaryCategory={experience.primaryCategory?.name} />
            <Group direction="vertical">
              <Heading variant="heading6" lineClamp={3} colour="neutral-one">{experience.name}</Heading>
              <ProductTypeLabel productType={experience.productType} kind="plain" />
              {experience.vendor && <BodyText variant="medium" colour="neutral-two">{experience.vendor?.name}</BodyText>}
            </Group>
            {experience.cancellationPolicies.length > 0 && (
              <BodyText colour="primary" variant="medium">
                {hasFullRefund && 'Free cancellation'}
                {!hasFullRefund && 'Flexible cancellation'}
              </BodyText>
            )}
          </Group>
          <HeroExperienceOfferTilePricing experience={experience}/>
        </MinHeightGroup>
      </DetailContainer>
    </PaletteProvider>
  )
}

export default HeroExperienceOfferDetails
